var image_viewer_rtlignore_default = {
  "fontElementMap": "W9qu2",
  "imageFigure": "UHDUC",
  "imageContainer": "UUaGJ",
  "expandContainer": "xAArp",
  "expandIcon": "C05VS",
  "pointer": "_4qzNK",
  "imageWrapper": "SICym",
  "imageRatio": "MrPQf",
  "image": "oAE5y",
  "imageOverlay": "_486FI",
  "imagePreload": "R1Vwy",
  "imageHighres": "yJ-le",
  "onlyHighRes": "AcxMd",
  "image_loading": "n39yr"
};
export {
  image_viewer_rtlignore_default as default
};
//# sourceMappingURL=image-viewer.rtlignore-scss.js.map
